module.exports = __webpack_public_path__ + "28b52d56e1ee998f20b99c429ead1656.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/buy-bg.jpg
// module id = 194
// module chunks = 0